import React from "react";
import get from "lodash/get";
import { object, bool, string } from "prop-types";

import NewsHeadline from "../../atoms/NewsHeadline";
import Excerpt from "../../atoms/Excerpt";
import SectionHolder from "../../atoms/SectionHolder";
import LiveNewsHeadline from "../../atoms/liveNewsHeadline";
import SponsorDetails from "../../molecules/SponsorDetails";

import { getExcerpt } from "../../utils/utils";

const NewsWithNoImage = ({ story, showExcerpt = true, showDot = false, styles = {}, showSubHeading = true, Htag }) => {
  const excerpt = getExcerpt(story);
  const showLiveBlog = story["story-template"] === "live-blog";
  const sponsorId = get(story, ["metadata", "story-attributes", "sponsoredby", "0", "id"], null);
  return (
    <div className="news_with_no_image">
      {showLiveBlog ? (
        <LiveNewsHeadline story={story} showDot={showDot} styles={styles} Htag={Htag} />
      ) : (
        <NewsHeadline story={story} showDot={showDot} styles={styles} Htag={Htag} showSubHeading={showSubHeading} />
      )}
      {showExcerpt && <Excerpt excerpt={excerpt} excerptLink={story.url} />}
      {sponsorId && !showLiveBlog ? (
        <SponsorDetails sponsorId={sponsorId} showImage={false} />
      ) : (
        <SectionHolder story={story} />
      )}
    </div>
  );
};

NewsWithNoImage.propTypes = {
  story: object.isRequired,
  showExcerpt: bool,
  showDot: bool,
  styles: object,
  showSubHeading: bool,
  Htag: string,
};

export default NewsWithNoImage;
